import {
  reactive, ref, watch, toRef,
} from '@vue/composition-api'
import formatDate from '@/utils/date-format'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'

export default function useList(props, ctx) {
  const businessTypes = ref([])
  const getBusinessTypes = async () => {
    const res = await ctx.root.$store.dispatch('business/getBusinessTypes', {
      active: true,
    })
    const { data } = res.data.data
    businessTypes.value = data
  }
  getBusinessTypes()

  const tableColumns = [
    {
      label: 'Name',
      key: 'name',
      formatter: val => val.en,
    },
    {
      label: 'created at',
      key: 'createdAt',
      formatter: val => formatDate(val),
    },
    {
      label: 'Phone No',
      key: 'phoneNumber',
    },
    {
      label: 'Email',
      key: 'email',
    },
    {
      label: 'State',
      key: 'state',
      formatter: val => snakeCaseToCamelCase(val),
    },
    'actions',
  ]

  const loading = ref(false)
  const list = ref([])
  const total = ref(0)

  const queryParams = reactive({
    perPage: 10,
    page: 1,
    name: undefined,
    businessTypeLogicalId: null,
    email: undefined,
    phoneNumber: undefined,
  })

  const fetchList = async () => {
    try {
      const temp = { ...queryParams }
      loading.value = true
      Object.keys(temp).forEach(k => {
        if (!temp[k]) delete temp[k]
      })
      const res = await ctx.root.$store.dispatch('business/getBusinesses', temp)
      const { data } = res.data
      list.value = data.businesses
      total.value = data.total
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }

  const clearFilter = () => {
    queryParams.name = ''
    queryParams.businessTypeLogicalId = null
    queryParams.email = undefined
    queryParams.phoneNumber = undefined
    queryParams.page = 1
    fetchList()
  }

  const applySearch = () => {
    queryParams.page = 1
    fetchList()
  }
  watch([toRef(queryParams, 'perPage')], () => {
    fetchList()
  })
  fetchList()

  const businessTypeRedirection = (type, businessId, externalId) => {
    if (type === 'restaurant') {
      return `/businesses/food/details/${businessId}?externalId=${externalId}`
    } if (type === 'ride-hailing') {
      return `/businesses/ride-hailing/details/${businessId}?externalId=${externalId}`
    }
    return `/businesses/fleet-management/details/${businessId}?externalId=${externalId}`
  }

  return {
    businessTypeRedirection,
    applySearch,
    total,
    list,
    fetchList,
    loading,
    tableColumns,
    clearFilter,
    // transitionBusinessData,
    // transitionBusinessHandler,
    queryParams,
    businessTypes,
  }
}
